import { Routes } from '@angular/router';
import { LandingPageComponent } from './features/landing/landing-page.component';

export const routes: Routes = [
  {
    path: '',
    component: LandingPageComponent,
  },
  {
    path: 'privacy',
    loadComponent: () =>
      import('./features/legal/privacy.component').then(
        (m) => m.PrivacyComponent,
      ),
    title: 'Privacy Policy - Kaizenic',
  },
  {
    path: 'terms',
    loadComponent: () =>
      import('./features/legal/terms.component').then((m) => m.TermsComponent),
    title: 'Terms of Service - Kaizenic',
  },
  {
    path: '**',
    redirectTo: '',
  },
];
